'use client';

import { FC, useState } from 'react';

import { ElementProps, Node } from '@ravago/shared/page-data/models/base';
import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';
import { useTranslations } from '@ravago/shared/translations/client';

import { InviteColleagueForm } from './components/invite-colleague-form';

export const ButtonInviteColleagueElementServer: FC<ElementProps<Node>> = ({ globals: { businessContext, locale } }) => {
   const [formOpen, setFormOpen] = useState(false);
   const translate = useTranslations();

   return (
      <>
         <Button variant="primary" leadingIcon="user-plus" onClick={() => setFormOpen(true)}>
            {translate('portal-users.invite')}
         </Button>

         <InviteColleagueForm
            open={formOpen}
            contactEmail={businessContext?.emailAddress || ''}
            locale={locale}
            onClose={(userInvited) => {
               setFormOpen(false);

               if (userInvited) window.location.reload();
            }}
         />
      </>
   );
};
